export default {
  listTitleTable: {
    COM_GROUP_CODE: 'CHỈ SỐ',
    INDEX_VALUE: 'GIÁ',
    INDEX_CHANGE: 'THAY ĐỔI',
    PERCENT_INDEX_CHANGE: '% THAY ĐỔI',
    TOTAL_MATCH_VOLUME: 'KHỐI LƯỢNG',
    TOTAL_MATCH_VALUE: 'GIÁ TRỊ',
    FOREIGN_BUY_VALUE_MATCHED: 'KLNN MUA',
    FOREIGN_SELL_VALUE_MATCHED: 'KLNN BÁN',
    FOREIGN_NET_VOLUME: 'KLNN RÒNG',
    FOREIGN_NET_VALUE: 'GTNN RÒNG',
    TOTAL_DEAL_VOLUME: 'KLGD THỎA THUẬN',
    TOTAL_DEAL_VALUE: 'GTGD THỎA THUẬN',
  },
};
